enum ModalEnum {
    Search = "SEARCH",
    Mrqt = "MRQT",
    Login = "LOGIN",
    Disclaimer = "DISCLAIMER",
    Youtube = "YOUTUBE",
    AutoChecklist = "AUTO_CHECKLIST",
    Custom = "CUSTOM",
}

export default ModalEnum;